export function isLight(rgb) {
    if (rgb) {
        const values = rgb.match(/\d+/g).map(Number);
        const luminosity = 0.299 * values[0] + 0.587 * values[1] + 0.114 * values[2];
        const range = 128;
        return luminosity > range;
    }
    return false;
}
